import { ThemeProvider } from '@oneaudi/unified-web-common';
import React, { ReactNode } from 'react';
import { getThemeName } from '../../alpha-helpers';
import { CustomTheme } from '../FeatureAppTypes';

interface ThemeProps {
  theme: CustomTheme;
  children: ReactNode;
}

export const Theme: React.FC<ThemeProps> = ({ theme, children }) => {
  return <ThemeProvider theme={getThemeName(theme)}>{children}</ThemeProvider>;
};
